/**
 * @template T1, T2
 * @typedef {Omit<T1, keyof T2> & T2} Override<T1, T2>;
 */

export const Types = {}
